import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-map-pre",
  "use": "icon-map-pre-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-map-pre\">\n  <defs>\n    <style>\n      #icon-map-pre .cls-1 {\n        fill: #435480;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-map-pre_路径_985\" data-name=\"路径 985\" class=\"cls-1\" d=\"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4,8.882H7.754A.657.657,0,0,1,7.1,8.227V3.979a.656.656,0,1,1,1.312,0V7.571H12a.655.655,0,0,1,0,1.311Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol